import { getVisibleOoCaseSidebarItemIds, shouldShowOoOverviewNavItem } from '../buildOoCaseSidebar';
import type { OoCaseSidebarContext } from '../buildOoCaseSidebar';
import { CaseSidebarItemId } from '../types';
import { isCaseSidebarItemId } from './formSectionMapping';

export function mapOoCaseSidebarItemToUrlSection(itemId: CaseSidebarItemId): string {
  return itemId;
}

export function normalizeOoSectionParam(
  section: string | null | undefined,
  context: OoCaseSidebarContext,
): CaseSidebarItemId | undefined {
  if (!section || !isCaseSidebarItemId(section)) {
    return undefined;
  }

  if (!context.isNewSectionsEnabled && section === CaseSidebarItemId.OVERVIEW && shouldShowOoOverviewNavItem(context)) {
    return CaseSidebarItemId.CUSTOMER_FILES;
  }

  return section as CaseSidebarItemId;
}

export function resolveOoCaseSidebarItemId(
  section: string | null | undefined,
  context?: OoCaseSidebarContext,
): CaseSidebarItemId | undefined {
  if (!section || !isCaseSidebarItemId(section)) {
    return undefined;
  }

  if (!context) {
    return section as CaseSidebarItemId;
  }

  const normalizedSection = normalizeOoSectionParam(section, context);

  if (!normalizedSection) {
    return undefined;
  }

  const allowedItemIds = getVisibleOoCaseSidebarItemIds(context);

  if (!allowedItemIds.includes(normalizedSection)) {
    return undefined;
  }

  return normalizedSection;
}
